import { Injectable } from '@angular/core';
import { ProToolsUiManagerService } from './pro-tools-ui-manager.service';
import { ViewSwitcherService } from './view-switcher.service';
// import { TopToolbarComponent } from '../top-toolbar/top-toolbar.component';


@Injectable()
export class TopToolbarService {
  constructor(
    private proToolsUiManagerService: ProToolsUiManagerService,
    private viewSwitcher: ViewSwitcherService,
    // private topToolBarComponent: TopToolbarComponent,
  ) {}

  switchTo2D(value: boolean) {
    if (this.proToolsUiManagerService.getIsProToolsMode() && !value) {
      // this.showToast('warning', 'Warning', '3D view is not available in Pro Tools mode');
      return;
    }
    this.viewSwitcher.switchView(value);
    // this.topToolBarComponent.is2D = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/topToolbar.service.ts